import { render, staticRenderFns } from "./ProductsGrid.vue?vue&type=template&id=9ee2a48c&"
import script from "./ProductsGrid.vue?vue&type=script&lang=js&"
export * from "./ProductsGrid.vue?vue&type=script&lang=js&"
import style0 from "./ProductsGrid.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports